export const registerObject = (name, email, password, employeeId) => {
  // let inputName = '' ? 'Name can not be empty' : name;
  // let inputEmail = '' ? 'Email can not be empty': email;
  // let inputPassword = '' ? 'Password can not be empty' : password;
  let result = {
    email: email,
    id: employeeId,
    password: password,
    profiles: [],
    username: name,
  }

  return result
}
